// src/components/RoleModal.tsx
import React, { useState, useEffect } from 'react';
import {createRole, updateRole} from "../auth";

interface RoleModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: () => void;
    role: any;
}

const RoleModal: React.FC<RoleModalProps> = ({ isOpen, onClose, onSave, role }) => {
    const [id, setId] = useState('');
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (role) {
            setId(role.id);
            setName(role.name);
            setDescription(role.description);
        } else {
            setId('');
            setName('');
            setDescription('');
        }
    }, [role]);

    const handleCreate = async (name : string, description : string) => {
        try {
            await createRole({"name" : name, "description" : description});
        } catch (error) {
            console.error('Erreur lors de la création du rôle:', error);
        }
    };

    const handleUpdate = async (id: number, name : string, description : string)=> {
        try{
            await updateRole(id,{"id" : id, "name" : name, "description" : description})
        } catch (error) {
            console.error('Erreur lors de la mise à jour du rôle:', error);
        }
    }

    const handleSave = async () => {
        if (role) {
            // Mettre à jour le rôle
            const id = role.id;
            handleUpdate(id,name,description)
                .then(response => {
                    console.log('Rôle modifié:');
                    onSave();
                    onClose();
                })
                .catch(error => {
                    console.error('Erreur lors de la modification du rôle:', error);
                });
        } else {
            // Créer un nouveau rôle
            handleCreate(name,description)
                .then(response => {
                    console.log('Rôle ajouté:');
                    onSave();
                    onClose();
                })
                .catch(error => {
                    console.error('Erreur lors de la création du rôle:', error);
                });
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
                <h2 className="text-xl font-bold mb-4">
                    {role ? 'Modifier le rôle' : 'Créer un rôle'}
                </h2>
                <div className="mb-4">
                    <label className="block text-gray-700">Identifiant du rôle</label>
                    <input
                        type="text"
                        className="w-full p-2 mt-2 border rounded-md bg-gray-100"
                        value={id}
                        readOnly={true}
                        onChange={(e) => setId(e.target.value)}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700">Nom du rôle</label>
                    <input
                        type="text"
                        className="w-full p-2 mt-2 border rounded-md"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700">Description</label>
                    <input
                        type="text"
                        className="w-full p-2 mt-2 border rounded-md"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>
                <div className="flex justify-end">
                    <button
                        onClick={onClose}
                        className="bg-gray-500 text-white px-4 py-2 rounded-md mr-2"
                    >
                        Annuler
                    </button>
                    <button
                        onClick={handleSave}
                        className="bg-blue-500 text-white px-4 py-2 rounded-md"
                    >
                        Sauvegarder
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RoleModal;
